import { useTranslation } from 'react-i18next';
import { S } from '../regureStyles';

const SignerAvatars = ({ signers = [] }) => {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {signers.slice(0, 4).map((s, i) => (
        <div
          key={i}
          title={t('screens.esign.signerTooltip', { name: s.name, status: s.status })}
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: s.status === 'signed' ? '#10b981' : s.status === 'declined' ? '#ef4444' : S.burgundy,
            border: '2px solid #fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: 10,
            fontWeight: 700,
            marginLeft: i > 0 ? -8 : 0,
            position: 'relative',
            zIndex: signers.length - i,
          }}
        >
          {(s.name || 'U').slice(0, 2).toUpperCase()}
        </div>
      ))}
      {signers.length > 4 && <span style={{ marginLeft: 4, fontSize: 11, color: S.textMuted }}>+{signers.length - 4}</span>}
    </div>
  );
};

export default SignerAvatars;
